<template>
  <Modal
    ref="modalRef"
    class="ai-bot-popup"
    v-bind="$attrs"
    v-on="$listeners"
    :maskClosable="false"
    :useCloseBtn="true"
  >
    <div class="btn-wrap">
      <van-button class="btn-item" round plain type="info" @click="goWorkTemp"
        >无法登录请点击
      </van-button>
      <van-button class="btn-item" round plain type="info" @click="goLogin"
        >登录
      </van-button>
    </div>
  </Modal>
</template>

<script>
import { clickButton } from '@plugins/biPoint/_configOfficialSupport';
import globalConfig from '@utiles/globalConfig';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import { buildWorkTempQuery } from '@utiles/officialSupport';
import { mapState } from 'vuex';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
const mainHost = globalConfig.getMainHost();
export default {
  mixins: [iframeMessage],
  props: {
    source: {
      type: String,
      default: ''
    },
    aiBotLink: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tempId: 10
    };
  },
  computed: {
    ...mapState({
      curLang: state => state.curLang
    })
  },
  methods: {
    goWorkTemp() {
      clickButton({
        btnName: 'clickGoSmartOrderAiPopup',
        locationKey: this.source || '',
        otherParams: {
          workTempId: this.tempId
        }
      });
      this.$router.push({
        name: 'worktemp',
        query: buildWorkTempQuery({
          workTempId: this.tempId,
          source: this.source || ''
        })
      });
    },
    goLogin() {
      clickButton({
        btnName: 'clickGoLoginAiPopup',
        locationKey: this.source || '',
        otherParams: {}
      });
      const link = `https://pay.${mainHost}/platform/login.html?gameId=191&language=${
        this.curLang
      }&forward=${encodeURIComponent(getGlobalGetGotoLink({ link: this.aiBotLink }))}`;
      const inWebOfficialSupport =
        globalConfig.getHrefParam('inWebOfficialSupport') == 1;
      if (inWebOfficialSupport) {
        this.postMessageToParent('locationLink', link);
      } else {
        window.location.href = link;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-bot-popup {
  .btn-wrap {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 80px;
  }
  .btn-item {
    width: 100%;
    margin: 0 5px;
  }
}
</style>
